// app/javascript/delete_handler.js

export function initDeleteHandler() {
  document.addEventListener("click", function (event) {
    // Catch links demanding a restful deletion or explicit data-method override
    const deleteLink = event.target.closest("a[data-method='delete']") || event.target.closest("a[data-turbo-method='delete']");
    if (!deleteLink) return;

    event.preventDefault();

    // Standard native verification check
    const confirmationMessage = deleteLink.getAttribute("data-confirm");
    if (confirmationMessage && !confirm(confirmationMessage)) {
      return;
    }

    // Programmatically construct an on-the-fly execution form wrapper
    const form = document.createElement("form");
    form.method = "POST";
    form.action = deleteLink.getAttribute("href");

    // Extract and append CSRF Security tokens securely
    const csrfMeta = document.querySelector("meta[name='csrf-token']");
    if (csrfMeta) {
      const csrfInput = document.createElement("input");
      csrfInput.type = "hidden";
      csrfInput.name = "authenticity_token";
      csrfInput.value = csrfMeta.content;
      form.appendChild(csrfInput);
    }

    // Append the RESTful routing method overwrite token (_method = DELETE)
    const methodInput = document.createElement("input");
    methodInput.type = "hidden";
    methodInput.name = "_method";
    methodInput.value = "DELETE";
    form.appendChild(methodInput);

    document.body.appendChild(form);
    form.submit();
  });
}
